module Notifications {
  var toastContainer;

  export function construct() {
    toastContainer = $("#ToastContainer");
  }

	export function Success(message: string, title: string = null): void
	{
    const successDuration = 2500;

    if (title == null) {
      Create(message, undefined, successDuration, "text-success");
      return;
    }

    Create(message, title, successDuration, "text-success");
	}

	export function Warning(message: string, title: string = null): void
  {
    const warningDuration = 5000;

		if (title == null)
		{
      Create(message, undefined, warningDuration, "text-warning");
			return;
		}

    Create(message, title, warningDuration, "text-warning");
	}

	export function ChangeSaved()
	{
    Create("Change saved!", undefined, 1000, "text-success");
  }

  export function Create(message: string, title: string = "Notification", duration: number = 2000, titleClasses: string = "") {
    const html = [
      `<div class="toast">` + 
        `<div class="toast-header">` + 
          //`<img src="..." class="rounded mr-2" alt="...">` + 
          `<strong class="mr-auto ${titleClasses}">${title}</strong>` +
          `<button type="button" class="ml-2 mb-1 close" data-dismiss="toast">` + 
            `<span>&times;</span>` + 
          `</button>` + 
        `</div>` + 
        `<div class="toast-body">` + 
          message + 
        `</div>` + 
      `</div>`
    ].join("\n");
    const jqueryElement : any = $(html);
    jqueryElement.toast({ delay: duration });
    toastContainer.append(jqueryElement);
    jqueryElement.toast("show");
  }
}